// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Search Section CSS Module
 * Grid layout for search results matching single-view sections
 */
.YGRfJHHyEJ2MVbMytpCW {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: var(--status-bar-height);
  background: var(--search-background, #2f2f2f);
  /* Match old lobby color */
  z-index: 110;
  display: flex;
  flex-direction: column;
}
.YGRfJHHyEJ2MVbMytpCW.IEKwuNKD1pjpQZCZTS5I {
  bottom: 1px;
  top: 31px;
  left: 1px;
  width: calc(100% - 2px);
  border-radius: 0 0 10px 10px;
}
@media (min-width: 430px) {
  .YGRfJHHyEJ2MVbMytpCW {
    bottom: var(--status-bar-height);
  }
}
@media (min-width: 768px) {
  .YGRfJHHyEJ2MVbMytpCW {
    bottom: var(--status-bar-height);
  }
}
.xxKrnySnedcEx8ekcObq {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px;
  position: relative;
  min-width: 0;
}
.kBAHpSPImgilZIbCjE2N {
  font-family: 'Futura PT', sans-serif;
  font-weight: 500;
  font-size: 20px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1;
  padding: 0 0 8px;
}
._72xo5EKP9kopDiLmCOG {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 22px;
  min-width: 30px;
  min-height: 22px;
  background: transparent;
  border: none;
  cursor: pointer;
  color: #ffffff;
  flex-shrink: 0;
}
._72xo5EKP9kopDiLmCOG:hover {
  opacity: 0.8;
}
.pDZHfckQmcBtJjQbId6m {
  flex: 1;
  display: flex;
  align-items: center;
  min-width: 0;
  background: #ffffff;
  border-radius: 8px;
  padding: 0 0 0 12px;
  height: 40px;
}
.H0WXhgslpAL8ZOLLxjMF {
  flex: 1;
  min-width: 0;
  background: transparent;
  border: none;
  padding: 8px 0;
  color: #1C1C1E;
  font-size: 16px;
  outline: none;
}
.H0WXhgslpAL8ZOLLxjMF:focus {
  border: none;
  box-shadow: none;
}
.H0WXhgslpAL8ZOLLxjMF::placeholder {
  color: #9D9D9D;
  font-size: 16px;
}
.l5aLVF_3PvVdnVatdU4o {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  color: #1C1C1E;
  padding: 0;
  flex-shrink: 0;
  margin-right: 0;
}
.l5aLVF_3PvVdnVatdU4o:hover {
  color: #1C1C1E;
}
.XlTFO1fdqZesIpmM06bg {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  border: 1px solid transparent;
  border-radius: 10px;
  background-color: var(--search-action-background, #48494B);
  cursor: pointer;
  flex-shrink: 0;
}
.XlTFO1fdqZesIpmM06bg:hover {
  opacity: 0.9;
}
.qDRq7O3iO4r23rOe8cyJ {
  border: 1px solid #848383;
  background-color: var(--search-action-background-active, #616262);
  box-shadow: 0px 0px 4px 0px #000000CC;
}
/* Filter badge - pilotGreen from theme */
.szyeEVawhgMhjh15xiS2 {
  position: absolute;
  top: -8px;
  right: -8px;
  width: auto;
  height: auto;
  min-width: 17px;
  min-height: 17px;
  padding: 0 4px 0 4.5px;
  background: var(--piliot-green, #3CFF00);
  border-radius: 38px;
  font-size: 16px;
  font-weight: 450;
  color: #313131;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  box-shadow: 0px 0px 4px 0px #000000CC;
}
.mtm46i0ICEvsIlnOakwW {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 12px 16px;
  /* Custom scrollbar */
  scrollbar-width: thin;
  scrollbar-color: #555555 #48494B;
}
.mtm46i0ICEvsIlnOakwW::-webkit-scrollbar {
  width: 8px;
}
.mtm46i0ICEvsIlnOakwW::-webkit-scrollbar-track {
  background: #48494B;
  border-radius: 4px;
}
.mtm46i0ICEvsIlnOakwW::-webkit-scrollbar-thumb {
  background: #555555;
  border-radius: 4px;
}
.mtm46i0ICEvsIlnOakwW::-webkit-scrollbar-thumb:hover {
  background: #666666;
}
@media (min-width: 430px) {
  .mtm46i0ICEvsIlnOakwW {
    padding: 0 8px 8px;
  }
}
@media (min-width: 768px) {
  .mtm46i0ICEvsIlnOakwW {
    padding: 8px 8px 24px;
  }
}
@media (min-width: 1024px) {
  .mtm46i0ICEvsIlnOakwW {
    padding: 8px 8px 32px;
  }
}
/* Games Grid. \`--columns\` is set inline on \`.resultsContainer\` (SearchSection.tsx) from
   the container's own measured width via ResizeObserver, not from CSS \`@media (min-width)\`
   breakpoints. \`.searchContainer\` is \`position: fixed\`, and on iOS Safari a fixed-position
   element's box can keep a stale width across a portrait -> landscape -> portrait cycle
   even though a viewport-media-query would itself re-evaluate correctly — measuring the
   actual box instead sidesteps that. See useMeasuredColumnCount for the breakpoint values. */
.BUVu9aBK6CSYhNag8s8h {
  display: grid;
  grid-template-columns: repeat(var(--columns, 2), minmax(0, 1fr));
  grid-auto-rows: auto;
  overflow-y: visible;
  overflow-x: visible;
  flex: unset;
  height: auto;
  gap: var(--grid-gap);
  padding: 0;
  justify-items: center;
  align-items: start;
  /* Smooth scrolling */
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
}
.RwnxkODQxx5eJkTIbwQ8 {
  text-align: center;
  color: rgba(255, 255, 255, 0.6);
  font-size: 18px;
  margin-top: 60px;
}
/* Search placeholder when no text entered */
.uuH9s7KcJaG2thEJ72wF {
  width: 230px;
  max-width: 100%;
  height: 118px;
  background: var(--search-surface-deep, #232424);
  border: 1px solid #707070;
  border-radius: 3px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  padding: 10px;
  color: #fff;
  font-size: 16px;
}
.uuH9s7KcJaG2thEJ72wF svg {
  width: 40px;
  height: 40px;
  color: #fff;
}
/* Chrome, Edge, Safari */
input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: none;
  appearance: none;
}
/* Optional: also hide other built-in decorations */
input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
  display: none;
}
/* Firefox */
input[type="search"]::-moz-search-clear-button {
  display: none;
}
/* IE / Edge (Legacy) */
input[type="search"]::-ms-clear {
  display: none;
  width: 0;
  height: 0;
}
`, "",{"version":3,"sources":["webpack://./src/features/search/components/SearchSection/SearchSection.module.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,gCAAgC;EAChC,6CAA6C;EAC7C,0BAA0B;EAC1B,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,SAAS;EACT,SAAS;EACT,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;EACE;IACE,gCAAgC;EAClC;AACF;AACA;EACE;IACE,gCAAgC;EAClC;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,OAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,cAAc;EACd,eAAe;EACf,aAAa;AACf;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,UAAU;EACV,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,0DAA0D;EAC1D,eAAe;EACf,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,iEAAiE;EACjE,qCAAqC;AACvC;AACA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,wCAAwC;EACxC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,qCAAqC;AACvC;AACA;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,gCAAgC;AAClC;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;;;;;6FAK6F;AAC7F;EACE,aAAa;EACb,gEAAgE;EAChE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,iCAAiC;AACnC;AACA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;AACA,4CAA4C;AAC5C;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,+CAA+C;EAC/C,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;AACb;AACA,yBAAyB;AACzB;EACE,wBAAwB;EACxB,gBAAgB;AAClB;AACA,mDAAmD;AACnD;;;EAGE,aAAa;AACf;AACA,YAAY;AACZ;EACE,aAAa;AACf;AACA,uBAAuB;AACvB;EACE,aAAa;EACb,QAAQ;EACR,SAAS;AACX","sourcesContent":["/**\n * Search Section CSS Module\n * Grid layout for search results matching single-view sections\n */\n.searchContainer {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: var(--status-bar-height);\n  background: var(--search-background, #2f2f2f);\n  /* Match old lobby color */\n  z-index: 110;\n  display: flex;\n  flex-direction: column;\n}\n.searchContainer.ingame {\n  bottom: 1px;\n  top: 31px;\n  left: 1px;\n  width: calc(100% - 2px);\n  border-radius: 0 0 10px 10px;\n}\n@media (min-width: 430px) {\n  .searchContainer {\n    bottom: var(--status-bar-height);\n  }\n}\n@media (min-width: 768px) {\n  .searchContainer {\n    bottom: var(--status-bar-height);\n  }\n}\n.searchHeader {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px;\n  position: relative;\n  min-width: 0;\n}\n.searchSectionHeader {\n  font-family: 'Futura PT', sans-serif;\n  font-weight: 500;\n  font-size: 20px;\n  color: rgba(255, 255, 255, 0.7);\n  line-height: 1;\n  padding: 0 0 8px;\n}\n.backButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 22px;\n  min-width: 30px;\n  min-height: 22px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: #ffffff;\n  flex-shrink: 0;\n}\n.backButton:hover {\n  opacity: 0.8;\n}\n.searchInputWrapper {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  min-width: 0;\n  background: #ffffff;\n  border-radius: 8px;\n  padding: 0 0 0 12px;\n  height: 40px;\n}\n.searchInput {\n  flex: 1;\n  min-width: 0;\n  background: transparent;\n  border: none;\n  padding: 8px 0;\n  color: #1C1C1E;\n  font-size: 16px;\n  outline: none;\n}\n.searchInput:focus {\n  border: none;\n  box-shadow: none;\n}\n.searchInput::placeholder {\n  color: #9D9D9D;\n  font-size: 16px;\n}\n.clearButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: #1C1C1E;\n  padding: 0;\n  flex-shrink: 0;\n  margin-right: 0;\n}\n.clearButton:hover {\n  color: #1C1C1E;\n}\n.headerActionButton {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  min-width: 40px;\n  min-height: 40px;\n  border: 1px solid transparent;\n  border-radius: 10px;\n  background-color: var(--search-action-background, #48494B);\n  cursor: pointer;\n  flex-shrink: 0;\n}\n.headerActionButton:hover {\n  opacity: 0.9;\n}\n.headerActionButtonActive {\n  border: 1px solid #848383;\n  background-color: var(--search-action-background-active, #616262);\n  box-shadow: 0px 0px 4px 0px #000000CC;\n}\n/* Filter badge - pilotGreen from theme */\n.filterBadge {\n  position: absolute;\n  top: -8px;\n  right: -8px;\n  width: auto;\n  height: auto;\n  min-width: 17px;\n  min-height: 17px;\n  padding: 0 4px 0 4.5px;\n  background: var(--piliot-green, #3CFF00);\n  border-radius: 38px;\n  font-size: 16px;\n  font-weight: 450;\n  color: #313131;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n  box-shadow: 0px 0px 4px 0px #000000CC;\n}\n.resultsContainer {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 12px 16px;\n  /* Custom scrollbar */\n  scrollbar-width: thin;\n  scrollbar-color: #555555 #48494B;\n}\n.resultsContainer::-webkit-scrollbar {\n  width: 8px;\n}\n.resultsContainer::-webkit-scrollbar-track {\n  background: #48494B;\n  border-radius: 4px;\n}\n.resultsContainer::-webkit-scrollbar-thumb {\n  background: #555555;\n  border-radius: 4px;\n}\n.resultsContainer::-webkit-scrollbar-thumb:hover {\n  background: #666666;\n}\n@media (min-width: 430px) {\n  .resultsContainer {\n    padding: 0 8px 8px;\n  }\n}\n@media (min-width: 768px) {\n  .resultsContainer {\n    padding: 8px 8px 24px;\n  }\n}\n@media (min-width: 1024px) {\n  .resultsContainer {\n    padding: 8px 8px 32px;\n  }\n}\n/* Games Grid. `--columns` is set inline on `.resultsContainer` (SearchSection.tsx) from\n   the container's own measured width via ResizeObserver, not from CSS `@media (min-width)`\n   breakpoints. `.searchContainer` is `position: fixed`, and on iOS Safari a fixed-position\n   element's box can keep a stale width across a portrait -> landscape -> portrait cycle\n   even though a viewport-media-query would itself re-evaluate correctly — measuring the\n   actual box instead sidesteps that. See useMeasuredColumnCount for the breakpoint values. */\n.gamesGrid {\n  display: grid;\n  grid-template-columns: repeat(var(--columns, 2), minmax(0, 1fr));\n  grid-auto-rows: auto;\n  overflow-y: visible;\n  overflow-x: visible;\n  flex: unset;\n  height: auto;\n  gap: var(--grid-gap);\n  padding: 0;\n  justify-items: center;\n  align-items: start;\n  /* Smooth scrolling */\n  scroll-behavior: smooth;\n  -webkit-overflow-scrolling: touch;\n}\n.noResultsMessage {\n  text-align: center;\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 18px;\n  margin-top: 60px;\n}\n/* Search placeholder when no text entered */\n.searchPlaceholder {\n  width: 230px;\n  max-width: 100%;\n  height: 118px;\n  background: var(--search-surface-deep, #232424);\n  border: 1px solid #707070;\n  border-radius: 3px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-evenly;\n  padding: 10px;\n  color: #fff;\n  font-size: 16px;\n}\n.searchPlaceholder svg {\n  width: 40px;\n  height: 40px;\n  color: #fff;\n}\n/* Chrome, Edge, Safari */\ninput[type=\"search\"]::-webkit-search-cancel-button {\n  -webkit-appearance: none;\n  appearance: none;\n}\n/* Optional: also hide other built-in decorations */\ninput[type=\"search\"]::-webkit-search-decoration,\ninput[type=\"search\"]::-webkit-search-results-button,\ninput[type=\"search\"]::-webkit-search-results-decoration {\n  display: none;\n}\n/* Firefox */\ninput[type=\"search\"]::-moz-search-clear-button {\n  display: none;\n}\n/* IE / Edge (Legacy) */\ninput[type=\"search\"]::-ms-clear {\n  display: none;\n  width: 0;\n  height: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchContainer": `YGRfJHHyEJ2MVbMytpCW`,
	"ingame": `IEKwuNKD1pjpQZCZTS5I`,
	"searchHeader": `xxKrnySnedcEx8ekcObq`,
	"searchSectionHeader": `kBAHpSPImgilZIbCjE2N`,
	"backButton": `_72xo5EKP9kopDiLmCOG`,
	"searchInputWrapper": `pDZHfckQmcBtJjQbId6m`,
	"searchInput": `H0WXhgslpAL8ZOLLxjMF`,
	"clearButton": `l5aLVF_3PvVdnVatdU4o`,
	"headerActionButton": `XlTFO1fdqZesIpmM06bg`,
	"headerActionButtonActive": `qDRq7O3iO4r23rOe8cyJ`,
	"filterBadge": `szyeEVawhgMhjh15xiS2`,
	"resultsContainer": `mtm46i0ICEvsIlnOakwW`,
	"gamesGrid": `BUVu9aBK6CSYhNag8s8h`,
	"noResultsMessage": `RwnxkODQxx5eJkTIbwQ8`,
	"searchPlaceholder": `uuH9s7KcJaG2thEJ72wF`
};
export default ___CSS_LOADER_EXPORT___;
